var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-app-bar",
        {
          attrs: {
            flat: "",
            color: "primary",
            role: "navigation",
            "aria-labelledby": "communities-title",
          },
        },
        [
          _c(
            "v-toolbar-title",
            { staticClass: "text-body-2", attrs: { id: "communities-title" } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("components.communities.title")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c("v-progress-linear", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isLoading,
                expression: "isLoading",
              },
            ],
            attrs: {
              color: "accent",
              indeterminate: "",
              "aria-label": "Loading",
              role: "status",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          attrs: {
            wrap: "",
            role: "region",
            "aria-label": "List of communities",
          },
        },
        _vm._l(_vm.communities, function (community) {
          var _obj
          return _c(
            "v-flex",
            _vm._b(
              { key: community.id },
              "v-flex",
              ((_obj = {}),
              (_obj[
                "xs" +
                  community.flexExtraSmall +
                  " sm" +
                  community.flexSmall +
                  " md" +
                  community.flexMedium +
                  " lg" +
                  community.flexLarge
              ] = true),
              _obj),
              false
            ),
            [
              community.isActive
                ? _c(
                    "v-card",
                    {
                      staticClass: "mb-4",
                      attrs: {
                        "aria-labelledby": "community-title-" + community.id,
                        role: "group",
                        "aria-label": _vm.$t(community.title),
                      },
                    },
                    [
                      _c("v-img", {
                        staticClass: "elevation-1",
                        attrs: {
                          alt: _vm.$t(community.title),
                          src: community.img,
                          height: "100px",
                          role: "img",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-card-title", { attrs: { "primary-title": "" } }, [
                        _c("div", [
                          _c(
                            "h3",
                            {
                              staticClass: "h5 mb-1",
                              attrs: { id: "community-title-" + community.id },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t(community.title)) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "grey--text text-subtitle-2" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t(community.subtitle)) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                "aria-label": _vm.$t(
                                  "components.communities.buttons.view"
                                ),
                                text: "",
                                color: "accent",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.viewCommunityCard(community.link)
                                },
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.viewCommunityCard(community.link)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "components.communities.buttons.view"
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                "aria-expanded": _vm.isCardVisible(community.id)
                                  ? "true"
                                  : "false",
                                "aria-controls":
                                  "community-details-" + community.id,
                                color: _vm.isCardVisible(community.id)
                                  ? "accent"
                                  : "",
                                icon: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleCommunityCard(community.id)
                                },
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.toggleCommunityCard(community.link)
                                },
                              },
                            },
                            [
                              _c("v-icon", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.isCardVisible(community.id)
                                        ? "keyboard_arrow_down"
                                        : "keyboard_arrow_up"
                                    ) +
                                    "\n            "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-slide-y-transition",
                        [
                          _c(
                            "v-card-text",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isCardVisible(community.id),
                                  expression: "isCardVisible(community.id)",
                                },
                              ],
                              staticClass: "pt-0",
                              attrs: {
                                id: "community-details-" + community.id,
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t(community.brief)) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }